import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.Filter),
  () => import('./Filter'),
  (Filter) => {
    ComponentUtil.binder(Hooks.Filter, Filter);
  },
);
